<template>
    <v-menu bottom left v-if="allowed_mobile_list.length > 0" :class="{ 'hidden-md-and-up': typeof(persistent) == 'undefined' }" content-class="no-stripe">
        <v-btn icon slot="activator">
            <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
            <v-list-tile v-for="item in allowed_mobile_list" :key="item.title" @click="$emit('invoke-method', item)">
                <v-list-tile-title>
                    {{ item.title }}
                </v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
	export default {
		props: ["mobileList", "persistent"],
        computed: {
            // filters mobile list by perms array if present
            allowed_mobile_list(){
                return this.mobileList && this.mobileList.length > 0 ? this.mobileList.filter(option => !option.perms || (option.perms && option.perms.every(perm => this.hasPerm(perm)))) : []
            }
        }
	};
</script>